import { render, staticRenderFns } from "./NotificationsMessagesNav.vue?vue&type=template&id=4ad4c95b&"
import script from "./NotificationsMessagesNav.vue?vue&type=script&lang=js&"
export * from "./NotificationsMessagesNav.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsMessagesNav.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports